import * as api from "services/Api";

export const loadTaxData = (tenant: string, asof: string, completeAllocations: boolean) => {
    const sources = api.getTaxSources(tenant);
    // Registration details must include every linked transaction, even when the
    // report's valuation date precedes its payout. Tax still calculates the view.
    const records = completeAllocations
        ? sources.then(options => api.getTaxRecords(tenant, options.reduce((latest, source) => source.date > latest ? source.date : latest, asof)))
        : api.getTaxRecords(tenant, asof);
    return Promise.all([records, sources]);
};
